import store from '@/store'

export default class ScoreType {
  constructor (data) {
    this.id = data.id
    this.name = data.nameFr
    this.order = data.order
    this.main = data.main
    this.unitId = data.unitId
  }

  getUnit () { return store.getters['Sport/ScoreTypeUnit/get'](this.unitId) }
}
